import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../HeaderAdmin";
import Navbar from "../Navbar";
import "./EmailTemplates.css";
import { EMAIL_TEMPLATES_BASE_URL } from "../ApiDetails.js";

const EmailConditionsList = () => {
    const [emailTemplates, setEmailTemplates] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        axios
            .get(EMAIL_TEMPLATES_BASE_URL)
            .then((response) => {
                setEmailTemplates(response.data);
            })
            .catch((error) => {
                console.error("Error fetching email templates:", error);
            });
    }, []);

    const handleEdit = (id) => {
        navigate(`/emailDetails/${id}`);
    };

    const handleNavigateNewTemplate = () => {
        navigate("/emailNewTemplate");
    };

    return (
        <>
            <Header />
            <div className="reportsContainerPadding">
                <Navbar />
                <div className="emailTemplateConditionsContainer">
                    <Button
                        variant="outlined"
                        sx={{
                            marginLeft: "auto",
                        }}
                        onClick={handleNavigateNewTemplate}
                        className="emailTemplateButtons"
                    >
                        New Template
                    </Button>
                    <TableContainer
                        component={Paper}
                        className="emailTemplateConditionsTable"
                    >
                        <Table aria-label="styled table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Message Type</TableCell>
                                    <TableCell>Subject</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {emailTemplates.map((row) => (
                                    <TableRow key={row.emailId}>
                                        <TableCell style={{ textAlign: 'left' }}>{"  "}{row.emailMessageType}</TableCell>
                                        <TableCell style={{ textAlign: 'left' }}>{"  "}{row.emailSubject}</TableCell>
                                        <TableCell className="emailTableActionButtons">
                                            <FontAwesomeIcon
                                                icon={faEdit}
                                                onClick={() => handleEdit(row.emailId)}
                                                style={{ cursor: "pointer" }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </>
    );
};

export default EmailConditionsList;
